export const expertVerification_style = {
  doctorSx: {
    color: '#0E1824',
    fontSize: '16px',
    fontWeight: 600,
    mt: 1,
  },
  descriptionSx: {
    color: '#808080',
    fontSize: '12px',
    mt: 1,
  },
  illustartionSx: {
    mt: 5,
    mb: 1,
    width: '419px',
    height: '324px',
  },
  footerSx: {
    color: '#007965',
    fontSize: '16px',
    textAlign: 'right',
    mt: 5,
    cursor: 'pointer',
  },
};
